import { goLogin, logout, getUserMenu } from '../assets/js/api.js'
import { getToken, setToken, removeToken } from '../utils/auth'
const user = {
  state: {
      user: {},
      status: '',
      code: '',
      token: getToken(),
      id: 0,
      name: '',
      avatar: '',
      introduction: '',
      roles: [],
      menus: [], // 菜单权限
      // 按钮级权限管控 - ①新增 button 全局变量
      buttons: [], // 按钮权限
      setting: {
          articlePlatform: []
      },
      term: []
  },

  mutations: {
      SET_USER: (state, user) => {
          state.user = user
      },
      SET_CODE: (state, code) => {
          state.code = code
      },
      SET_TOKEN: (state, token) => {
          state.token = token
      },
      SET_INTRODUCTION: (state, introduction) => {
          state.introduction = introduction
      },
      SET_SETTING: (state, setting) => {
          state.setting = setting
      },
      SET_STATUS: (state, status) => {
          state.status = status
      },
      SET_ID: (state, id) => {
          state.id = id
      },
      SET_NAME: (state, name) => {
          state.name = name
      },
      SET_AVATAR: (state, avatar) => {
          state.avatar = avatar
      },
      SET_ROLES: (state, roles) => {
          state.roles = roles
      },
      SET_MENUS: (state, menus) => {
          state.menus = menus
      },
      // 按钮级权限管控 - ②新增 mutations 操作 button
      SET_BUTTONS: (state, buttons) => {
          state.buttons = buttons
      },
      changeTerms(state, term) {
          state.term = term
      }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim();
      const password = userInfo.password
      return new Promise((resolve, reject) => {
        goLogin("front", userInfo.siteId,username, password).then(response => {
          const data = response.data;
          commit('SET_TOKEN', data.token);// 将token保存到cookie里 -> 作为前端用户已登录的标识
          setToken(response.data.token);
          localStorage.setItem("info", response.data.id);
          localStorage.setItem("username",response.data.username)
            localStorage.setItem("truename", response.data.trueName)
          localStorage.setItem("userInfo", JSON.stringify(response.data))
          localStorage.setItem("userSort", response.data.sort)
          resolve()
        }).catch(error => {
          // 登录失败，回传提示信息
          reject(error)
        })
      })
    },

    // 获取用户信息，相关权限数据
    GetUserMenu({ commit, state }) {
      return new Promise((resolve, reject) => {

        // 请求获取权限 -> 通过token查询
        getUserMenu(state.token).then(response => {
          if (!response.data) {
            reject('Verification failed, please login again.')
          }
          const data = response.data

          console.log("获取"+ "QUANXIAN")
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            // 当用户无任何权限时
            // commit('SET_ROLES', ['普通用户']);
            reject('getInfo: roles must be a non-null array!')
          }

          if (data.menus && data.menus.length > 0) { // 验证返回的menus是否是一个非空数组
            commit('SET_MENUS', data.menus)
          }

          // 按钮级权限管控 - ④将取到的 button 权限放到全局变量中
          if (data.buttons && data.buttons.length > 0) { // 验证返回的buttons是否是一个非空数组
            // 通过commit保存到全局变量
            commit('SET_BUTTONS', data.buttons)
          }

          commit('SET_USER', data)
          commit('SET_ID', data.id)
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.nickName)

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },


    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
            commit('SET_TOKEN', '');
         removeToken();
          resolve();
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        removeToken();
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      return new Promise(resolve => {
        commit('SET_TOKEN', role)
        setToken(role)
        getUserMenu(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_MENUS', data.menus)
          commit('SET_BUTTONS', data.buttons)

          dispatch('GenerateRoutes', data.menus) // 动态修改权限后 重绘侧边菜单
          resolve()
        })
      })
    }
  }
}

export default user
